import { Injectable } from '@angular/core';
// Helper
import { Helper } from '../helpers/helper';
import { HttpClient, HttpParams } from '@angular/common/http';
@Injectable()
export class ConfiguracionesService {

  constructor(private http: HttpClient, private helper: Helper) { }

  obtenerConfiguraciones() {
    return this.http.get(`${this.helper.urlServer}/api/v1/configuracion-prestamo/0`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  configurarOtrasConfiguraciones(data: any) {
    return this.http.put(`${this.helper.urlServer}/api/v1/configurar-otras-configuraciones`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).timeout(5000);
  }

  modeloCarta() {
    return this.http.get(`${this.helper.urlServer}/api/v1/modelo-carta`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  actualizarModeloCarta(data: any) {
    return this.http.put(`${this.helper.urlServer}/api/v1/configurar-modelo-carta`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).timeout(5000);
  }

  actualizarPagare(data: any) {
    return this.http.put(`${this.helper.urlServer}/api/v1/configurar-pagare-notarial`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).timeout(5000);
  }

  pagareNotarial() {
    return this.http.get(`${this.helper.urlServer}/api/v1/pagare-notarial`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  modeloBuroCredito() {
    return this.http.get(`${this.helper.urlServer}/api/v1/modelo-buro-credito`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  actualizarModeloBuroCredito(data: any) {
    return this.http.put(`${this.helper.urlServer}/api/v1/configurar-modelo-buro-credito`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).timeout(5000);
  }

  modeloCartaSaldo() {
    return this.http.get(`${this.helper.urlServer}/api/v1/modelo-carta-saldo`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  actualizarModeloCartaSaldo(data: any) {
    return this.http.put(`${this.helper.urlServer}/api/v1/configurar-modelo-carta-saldo`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).timeout(5000);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/configuraciones.service.ts